import Link from 'next/link'
import React from 'react'
import clsx from 'clsx'
import { sendAnalytics } from '@audio-network/analytics'
import sidebarStyles from '../Sidebar.module.css'
import styles from './ProjectList.module.css'
import useProjects from '@/stores/projectStore'

const ProjectList = (): JSX.Element => {
	const { projects } = useProjects()

	if (!projects || projects.length === 0) {
		return
	}

	const handleClick = (): void => {
		sendAnalytics({
			noun: 'Project',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Location: 'Music App Navigation',
			},
		})
	}

	return (
		<ul className={clsx(styles.projectList, sidebarStyles.showWhenExpanded)}>
			{projects.map((project) => (
				<li key={project.Id} className={styles.projectListItem}>
					<Link
						className={styles.project}
						href={`/project/edit/${project.Id}`}
						onClick={handleClick}
					>
						{project.Name}
					</Link>
				</li>
			))}
		</ul>
	)
}

export default ProjectList
